/** Enough reports that WCL fetching often gets slow, rate-limited, or times out. */
export const HEAVY_LOG_COUNT = 20;

export function isHeavyLogCount(count: number): boolean {
    return count >= HEAVY_LOG_COUNT;
}

export function heavyLogWarningText(count: number): string {
    return `${count} reports is a lot to process at once. This can take a long time, and it may time out or fail if Warcraft Logs rate-limits the requests.`;
}
